export default __webpack_public_path__ + "static/media/Merritt_Villas_Brochure.c93b6a0a.png";